<template>
  <div class="main">
    <a-form-model id="formLogin" ref="form" class="user-layout-login" :model="form" :rules="rules">
      <a-alert v-if="isLoginError" type="error" showIcon style="margin-bottom: 24px;" :message="loginErrorInfo" closable
        :after-close="handleCloseLoginError" />
      <a-form-model-item prop="accountNo">
        <a-input v-model="form.accountNo" size="large" placeholder="账户">
          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="password">
        <a-input-password v-model="form.password" size="large" placeholder="密码">
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
        </a-input-password>

      </a-form-model-item>
      <a-row :gutter="16" v-if="captchaEnabled">
        <a-col class="gutter-row" :span="16">
          <a-form-model-item prop="validCode">
            <a-input v-model="form.validCode" size="large" type="text" autocomplete="off" :placeholder="$t('app.setting.yanzhengma.yanzhengma')">
              <a-icon slot="prefix" type="security-scan" :style="{ color: 'rgba(0,0,0,.25)' }" />
            </a-input>
          </a-form-model-item>
        </a-col>
        <a-col class="gutter-row" :span="8">
          <img class="getCaptcha" :src="codeUrl" @click="getCode">
        </a-col>
      </a-row>
      <a-form-model-item prop="rememberMe">
        <a-checkbox :checked="form.rememberMe" @change="rememberMe">{{$t('app.setting.jizhumima.jizhumima')}}</a-checkbox>
      </a-form-model-item>
      <a-form-item style="margin-top:24px">
        <a-button size="large" type="primary" htmlType="submit" class="login-button" :loading="logining"
          :disabled="logining" @click="handleSubmit">{{$t('app.setting.login.confirm')}}</a-button>
      </a-form-item>

      <div class="user-login-other">
      </div>
    </a-form-model>

    <a-modal
      title="邮箱二次验证"
      :visible="mfaVisible"
      :confirmLoading="mfaSubmitting"
      :maskClosable="false"
      okText="验证并登录"
      cancelText="取消"
      @ok="handleMfaConfirm"
      @cancel="handleMfaCancel"
    >
      <p style="margin-bottom: 16px;">
        验证码将发送至 <strong>{{ mfaEmailMasked || '管理员邮箱' }}</strong>，验证通过后才可登录。
      </p>
      <a-form-model layout="vertical">
        <a-form-model-item label="邮箱验证码" required>
          <a-input-search
            v-model="mfaCode"
            size="large"
            placeholder="请输入邮箱验证码"
            :maxLength="8"
            @pressEnter="handleMfaConfirm"
          >
            <a-button
              slot="enterButton"
              type="primary"
              :disabled="mfaCountdown > 0 || mfaSending"
              :loading="mfaSending"
              @click="handleSendMfaCode"
            >
              {{ mfaCountdown > 0 ? `${mfaCountdown}s` : '发送验证码' }}
            </a-button>
          </a-input-search>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import { getCodeImg, sendAdminLoginEmailCode } from '@/api/login'
import { LOGIN_USERNAME, LOGIN_PASSWORD, LOGIN_REMEMBERME } from '@/store/mutation-types'
import storage from 'store'
import selectLang from '@/components/SelectLang'
export default {
  components: {
    selectLang
  },
  data() {
    return {
      codeUrl: '',
      isLoginError: false,
      loginErrorInfo: '',
      form: {
        accountNo: '',
        password: '',
        validCode: '',
        validCodeReqNo: '',
        rememberMe: false
      },
      rules: {
        accountNo: [{ required: true, message: '请输入帐户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        validCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      logining: false,
      captchaEnabled: true,
      redirect: undefined,
      mfaVisible: false,
      mfaSubmitting: false,
      mfaSending: false,
      mfaCode: '',
      mfaLoginTicket: '',
      mfaEmailMasked: '',
      mfaValidCodeReqNo: '',
      mfaCountdown: 0,
      mfaTimer: null
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    this.getStorage()
    if (this.captchaEnabled) {
      this.getCode()
    }
  },
  beforeDestroy() {
    this.clearMfaTimer()
  },
  methods: {
    getCode() {
      this.form.validCode = ''
      getCodeImg().then(res => {
        this.captchaEnabled = res.data.captchaEnabled === undefined ? true : res.data.captchaEnabled
        if (this.captchaEnabled) {
          this.codeUrl = 'data:image/gif;base64,' + res.data.img
          this.form.validCodeReqNo = res.data.uuid
        }
      })
    },
    getStorage() {
      const accountNo = storage.get(LOGIN_USERNAME)
      const password = storage.get(LOGIN_PASSWORD)
      const rememberMe = storage.get(LOGIN_REMEMBERME)
      if (accountNo) {
        Object.assign(this.form, {
          accountNo: accountNo,
          password: password,
          rememberMe: rememberMe
        })
      }
    },
    rememberMe(e) {
      this.form.rememberMe = e.target.checked
    },
    ...mapActions(['Login', 'Logout', 'ConfirmAdminEmailLogin']),

    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    handleSubmit() {
      this.logining = true
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.rememberMe) {
            storage.set(LOGIN_USERNAME, this.form.accountNo)
            storage.set(LOGIN_PASSWORD, this.form.password)
            storage.set(LOGIN_REMEMBERME, this.form.rememberMe)
          } else {
            storage.remove(LOGIN_USERNAME)
            storage.remove(LOGIN_PASSWORD)
            storage.remove(LOGIN_REMEMBERME)
          }
          this.$store.dispatch('Login', this.form).then((res) => {
            if (res && res.needEmailVerify) {
              this.mfaLoginTicket = res.loginTicket
              this.mfaEmailMasked = res.emailMasked || ''
              this.mfaCode = ''
              this.mfaValidCodeReqNo = ''
              this.mfaVisible = true
              this.logining = false
              this.handleSendMfaCode()
              return
            }
            this.$router.push({ path: this.redirect || '/' }).catch(() => {})
          }).catch((err) => {
            console.log('err', err)
            setTimeout(() => {
              this.logining = false
            }, 1000)
            if (this.captchaEnabled) {
              this.getCode()
            }
          })
        } else {
          setTimeout(() => {
            this.logining = false
          }, 600)
        }
      })
    },
    handleSendMfaCode() {
      if (!this.mfaLoginTicket || this.mfaCountdown > 0 || this.mfaSending) {
        return
      }
      this.mfaSending = true
      sendAdminLoginEmailCode(this.mfaLoginTicket).then(res => {
        if (res.success) {
          this.mfaValidCodeReqNo = res.data
          this.$message.success('验证码已发送，请查收邮箱')
          this.startMfaCountdown(60)
        } else {
          this.$message.error(res.message || '发送失败')
        }
      }).catch(() => {
        this.$message.error('发送失败，请稍后重试')
      }).finally(() => {
        this.mfaSending = false
      })
    },
    startMfaCountdown(seconds) {
      this.clearMfaTimer()
      this.mfaCountdown = seconds
      this.mfaTimer = setInterval(() => {
        if (this.mfaCountdown <= 1) {
          this.clearMfaTimer()
          this.mfaCountdown = 0
        } else {
          this.mfaCountdown -= 1
        }
      }, 1000)
    },
    clearMfaTimer() {
      if (this.mfaTimer) {
        clearInterval(this.mfaTimer)
        this.mfaTimer = null
      }
    },
    handleMfaConfirm() {
      if (!this.mfaCode || !this.mfaCode.trim()) {
        this.$message.warning('请输入邮箱验证码')
        return
      }
      if (!this.mfaValidCodeReqNo) {
        this.$message.warning('请先发送验证码')
        return
      }
      this.mfaSubmitting = true
      this.ConfirmAdminEmailLogin({
        loginTicket: this.mfaLoginTicket,
        validCode: this.mfaCode.trim(),
        validCodeReqNo: this.mfaValidCodeReqNo
      }).then(() => {
        this.mfaVisible = false
        this.$router.push({ path: this.redirect || '/' }).catch(() => {})
        setTimeout(() => {
          this.$notification.success({
            message: '欢迎',
            description: `${timeFix()}，欢迎回来`
          })
        }, 1000)
      }).catch(() => {
        // store 已弹错误提示
      }).finally(() => {
        this.mfaSubmitting = false
      })
    },
    handleMfaCancel() {
      this.mfaVisible = false
      this.mfaCode = ''
      this.mfaLoginTicket = ''
      this.mfaValidCodeReqNo = ''
      this.clearMfaTimer()
      this.mfaCountdown = 0
      if (this.captchaEnabled) {
        this.getCode()
      }
    },
    loginSuccess(res) {
      this.$router.push({ path: '/' })
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
      this.handleCloseLoginError()
    },
    requestFailed(err) {
      this.isLoginError = true
      this.loginErrorInfo = err
      this.form.code = undefined
      if (this.captchaEnabled) {
        this.getCode()
      }
    },
    handleCloseLoginError() {
      this.isLoginError = false
      this.loginErrorInfo = ''
    }
  }
}
</script>

<style lang="less" scoped>
.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .register {
      float: right;
    }
  }
}
</style>
